module.exports = __webpack_public_path__ + "img/top_safe04.22abfd7e.png";